import { Target } from "lucide-react";
import { DOMAIN_SHORT } from "@/lib/api";

const barColor = (s) => (s >= 70 ? "var(--ok)" : s >= 50 ? "var(--warn)" : "var(--alert)");

export const WeakSpots = ({ stats, onOpen }) => {
  const tried = stats.filter((d) => d.attempts > 0).sort((a, b) => a.avg_score - b.avg_score);
  const untried = stats.filter((d) => d.attempts === 0);
  if (!tried.length) return null;
  return (
    <section data-testid="weak-spot-tracker" className="mt-14">
      <h2 className="font-display text-lg font-bold flex items-center gap-2"><Target size={18} /> Weak spot tracker</h2>
      <p className="text-sm mt-1" style={{ color: "var(--ink-3)" }}>Average score per domain, lowest first. Tap a domain to practise it.</p>
      <div className="mt-4 card p-5 space-y-3">
        {tried.map((d) => (
          <button key={d.number} data-testid={`weak-spot-row-${d.number}`} onClick={() => onOpen(d.number)} className="w-full grid grid-cols-[minmax(120px,200px),1fr,auto] items-center gap-4 text-left group">
            <span className="text-sm truncate group-hover:underline">
              <span className="font-mono text-xs mr-1.5" style={{ color: "var(--ink-3)" }}>D{d.number}</span>{DOMAIN_SHORT[d.number - 1]}
            </span>
            <span className="h-2.5 rounded-full overflow-hidden" style={{ background: "var(--muted-bg)" }}>
              <span className="block h-full rounded-full transition-[width] duration-700" style={{ width: `${d.avg_score}%`, background: barColor(d.avg_score) }} />
            </span>
            <span className="font-mono text-sm font-bold w-24 text-right">
              {d.avg_score}% <span className="font-normal text-xs" style={{ color: "var(--ink-3)" }}>×{d.attempts}</span>
            </span>
          </button>
        ))}
        {untried.length > 0 && (
          <p data-testid="weak-spot-untried" className="text-xs pt-3 border-t" style={{ color: "var(--ink-3)", borderColor: "var(--line)" }}>
            Not yet attempted: {untried.map((d) => DOMAIN_SHORT[d.number - 1]).join(" · ")}
          </p>
        )}
      </div>
    </section>
  );
};
